import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Dialog, DialogContent, DialogActions, Button, Select, MenuItem,
  Grid,
} from '@material-ui/core';
import RyffineDialogTitle from '../common/RyffineDialogTitle';
import { showErrorSnackbar } from '../../redux/actions/appActions';
import { updateTaskProject } from '../../redux/actions/projectsActions';
import LoadingButton from '../common/LoadingButton';
import { MAIN_UI_COLOR } from '../../config';
import { TaskEntity } from '../../core/entities';

const ProjectChangeDialog = ({ task, projects, onClose }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [loading, setLoading] = useState(false);

  const [selectedProjectId, setSelectedProjectId] = useState(
    projects.some(p => p.id === task.project_id) ? task.project_id : '',
  );

  useEffect(() => {
    setSelectedProjectId(projects.some(p => p.id === task.project_id) ? task.project_id : '');
  }, [task, projects]);

  const handleProjectChange = e => {
    setSelectedProjectId(e.target.value === '' ? null : e.target.value);
  };

  const handleSave = () => {
    setLoading(true);

    dispatch(updateTaskProject(task.id, selectedProjectId))
      .then(() => history.push('/tasks'))
      .catch(() => showErrorSnackbar('Failed to update project.'))
      .finally(() => setLoading(false));
  };

  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <RyffineDialogTitle onClose={onClose}>
        Edit Project Assignment
      </RyffineDialogTitle>
      <DialogContent style={{ padding: '40px 40px 30px 40px' }}>
        <Select
          value={selectedProjectId ?? ''}
          onChange={handleProjectChange}
          fullWidth
          displayEmpty
        >
          <MenuItem key="no-project" value="">No Project</MenuItem>
          {projects.map(project => (
            <MenuItem key={project.id} value={project.id}>
              {project.name}
            </MenuItem>
          ))}
        </Select>
      </DialogContent>
      <DialogActions style={{ padding: 0 }}>
        <Grid
          container
          style={{
            padding: '16px 24px 16px 24px',
            background: MAIN_UI_COLOR,
          }}
        >
          <LoadingButton
            className="button create-task-button"
            style={{
              background: 'rgb(248, 248, 248)',
              minWidth: '110px',
            }}
            disabled={selectedProjectId === (task.project_id ?? null)}
            onClick={handleSave}
            loading={loading}
            variant="outlined"
            color="primary"
          >
            Save
          </LoadingButton>

          <Button
            style={{ marginLeft: '10px', color: '#ffffff' }}
            onClick={onClose}
            className="button"
          >
            Cancel
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

ProjectChangeDialog.propTypes = {
  task: PropTypes.oneOfType([
    PropTypes.instanceOf(TaskEntity),
    PropTypes.exact({}),
  ]).isRequired,
  projects: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ProjectChangeDialog;
